import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { EnvironmentRef } from '@hud/portal-dtos/webapp-common.dto';
import { PORTAL_BASE } from '../consts';

export default function useEnvironmentsQuery() {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: ['environments'],
    queryFn: async () => {
      const response = await client.get<EnvironmentRef[]>(
        `${PORTAL_BASE}/environments`,
      );
      return response.data;
    },
    enabled: isReady,
  });
}
